import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queryFragment = `_id
name
description
value
category
scope {
key
value
}
`

export const templateQuery = buildGraphqlQuery('Template', queryFragment)

export const buildQuery = (field) => buildGraphqlQuery('Template', `_id ${field}`)
